import { render } from "./BrochureForm.vue?vue&type=template&id=48beda96&scoped=true"
import script from "./BrochureForm.vue?vue&type=script&lang=js"
export * from "./BrochureForm.vue?vue&type=script&lang=js"

import "./BrochureForm.vue?vue&type=style&index=0&id=48beda96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48beda96"

export default script